export default __webpack_public_path__ + "static/media/ada.2ca7031b.png";